import plasticWrapStatus from 'constants/plasticWrapStatus';

export const getPlasticWrapStatusTitle = plasticWraptype => {
  const results = plasticWrapStatus.options.filter(obj => {
    return obj.id === plasticWraptype;
  });

  return results.length > 0 ? results[0].name : '';
};
